/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const SubHeading = styled.h3`
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const PaymentIconWrap = styled.span`
  margin-bottom: 8px;
`;

export const PaymentMethodsWrap = styled.div`
  display: grid;
  grid-template-columns: 336px 1fr 1fr;
  gap: 23px;
`;

export const PaymentMethod = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 32px;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const SmallText = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const Link = styled.div`
  color: ${Palette.Primary._500};
  cursor: pointer;
  text-decoration: underline;
`;

export const ExternalLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
